/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './Clipboard';

const ClipboardManager: ComponentManagerFn<'Clipboard'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'Clipboard'>(platform, 'Clipboard'),
    type: 'Clipboard',
    name: 'Clipboard',
    isChildAllowed: () => true, // any item can be dropped on clipboard
    isAllowedInsideParent: (page, parent) => parent.type === 'Page',
    defaultValue,
    props: {},
    layout: 'sizeAware', // to allow any layout to be dropped on this
    category: 'Forms',
    icon: { iconName: 'clipboard' },
    hideInComponentsList: true, // prevents from showing up in help docs and components sidebar tab
    description: `Clipboard is an internal component. Do not use this!

Used as a clipboard holder in page tree tab. isChildAllowed is true to allow any item to 
be dropped on the clipboard and is allowed only inside a Page. Page doesn't have Clipboard
as a allowable child and thus preventing this to show up on Context menu.`,
  };
};

export default ClipboardManager;
